import { render } from "./actionButtons.vue?vue&type=template&id=012fd20f&scoped=true"
import script from "./actionButtons.vue?vue&type=script&lang=js"
export * from "./actionButtons.vue?vue&type=script&lang=js"

import "./actionButtons.vue?vue&type=style&index=0&id=012fd20f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012fd20f"]])

export default __exports__